import {PrivateLoaderContext} from './types';

const contextMap = new Map<string, PrivateLoaderContext>();

export function setLoaderContext(
  key: string,
  value: PrivateLoaderContext,
): void {
  contextMap.set(key, value);
}

export function getLoaderContext(key: string) {
  const context = contextMap.get(key);

  if (!context) {
    throw new Error(`No context found with key: ${key}`);
  }

  return context;
}
